import React, {useEffect} from 'react';
import {ActionModal, useErrorHandler, ErrorModal} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {useFunds} from '../../../../entities';
import {useNavigate} from 'react-router';

interface DeleteFundModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  fundId: string;
}

export const DeleteFundModal = ({open, setOpen, fundId}: DeleteFundModalProps) => {
  const {deleteFundMutation} = useFunds();
  const navigate = useNavigate();

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Удаление фонда',
  });

  useEffect(() => {
    if (deleteFundMutation.error) {
      handleError(deleteFundMutation.error as unknown as ApiError);
    }
  }, [deleteFundMutation.error, handleError]);

  const handleSubmit = () => {
    deleteFundMutation.mutate(fundId, {
      onSuccess: () => {
        setOpen(false);
        navigate('/fundraisings/funds');
      },
    });
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handleSubmit}
        isLoading={deleteFundMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={'Удаление фонда'}
        textButtonApply={'Удалить'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
          Вы уверены, что хотите удалить этот фонд? Обратите внимание, что это действие безвозвратное{' '}
        </Text>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
